import { render, staticRenderFns } from "./get-tracking-number.vue?vue&type=template&id=2dae1dbe&scoped=true"
import script from "./get-tracking-number.vue?vue&type=script&lang=tsx"
export * from "./get-tracking-number.vue?vue&type=script&lang=tsx"
import style0 from "./get-tracking-number.vue?vue&type=style&index=0&id=2dae1dbe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dae1dbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/frontend_page_elephant/frontend_page_elephant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dae1dbe')) {
      api.createRecord('2dae1dbe', component.options)
    } else {
      api.reload('2dae1dbe', component.options)
    }
    module.hot.accept("./get-tracking-number.vue?vue&type=template&id=2dae1dbe&scoped=true", function () {
      api.rerender('2dae1dbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ops/get-tracking-number.vue"
export default component.exports